import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../../components/Header'
import hero from '../../images/our-advantage__hero.jpg'
import img01 from '../../images/our-advantage-1.jpg'
import img02 from '../../images/our-advantage-2.jpg'
import img03 from '../../images/our-advantage-3.jpg'

const Page = () => (
  <Fragment>
    <Helmet
      title="Our Advantage | Who We Are"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">
      Our Advantage
      </h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__content c-golden__wide">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/who-we-are">Who We Are</Link>
            </li>
            <li>
              <Link to="/who-we-are/our-advantage" activeClassName="is-active">
                Our Advantage
              </Link>
            </li>
          </ul>
          <div className="c-golden__text">
            <div className="c-golden__text-col">
            <h1 className="t-h1">
              Innovation, not Duplication
              </h1>
              <p className="t-p t-p-light">
              From the beginning, ATI’s philosophy has been “innovation, not duplication.“ Developing specialized technology solutions to connect over 30,000 accommodation, attraction, and transportation supplier partners to clients worldwide makes ATI an industry innovator. 
              </p>
              <p className="t-p t-p-light mt30">
              Reinventing the concept of escorted touring for new generations, our award winning “Airtours” feature a new and exciting multi-modal transportation concept, travelling by private air, rail, and deluxe motor coach, enabling both first time and return touring passengers to cover long distances efficiently, experiencing destinations in an in-depth yet hassle-free way.
              </p>
              <p className="t-p t-p-light mt30">
                Designed with flexibility at the forefront, ATI’s DriveAmerica
                concept offers more choices than ever before, allowing our
                customers to innovate, by customizing bespoke individual road
                trips across all 50 United States and Canada.
              </p>
            </div>
          </div>
          <div className="c-golden__next-page">
            <Link to="/who-we-are/our-mission" className="c-btn t-link mt30">
              Our Mission &nbsp;&#9654;
            </Link>
          </div>
        </div>
        <div className="c-golden__images c-golden__short min-laptop">
          <img src={img01} alt="" style={{ width: '50%', height: '100%' }} />
          <img src={img02} alt="" style={{ width: '50%', height: '50%' }} />
          <img src={img03} alt="" style={{ width: '50%', height: '50%' }} />
        </div>
      </div>
    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/who-we-are/our-advantage.js